import ContentOverlay from "../components/content_overlay";

function E_linksPage() {
  return (
    <ContentOverlay
      heading={<h2 style={{ textAlign: "center" }}>E-Links</h2>}
      text_content={
        <ol style={{ lineHeight: "2" }}>
          <li>
            Western Ghats Spatial Decision Support System{" "}
            <a href="https://wgbis.ces.iisc.ac.in/sdss/wgsdss/">
              https://wgbis.ces.iisc.ac.in/sdss/wgsdss/
            </a>
          </li>
          <li>
            Bangalore Lake Information system{" "}
            <a href="https://wgbis.ces.iisc.ac.in/sdss/BLIS/">
              https://wgbis.ces.iisc.ac.in/sdss/BLIS/
            </a>
          </li>
          <li>
            Bangalore Urban Information System{" "}
            <a href="https://wgbis.ces.iisc.ac.in/sdss/BUiS/about.html">
              https://wgbis.ces.iisc.ac.in/sdss/BUiS/about.html
            </a>
          </li>
          <li>
            Sahyadri Western Ghats Biodiversity Information System{" "}
            <a href="https://wgbis.ces.iisc.ac.in/biodiversity/">
              https://wgbis.ces.iisc.ac.in/biodiversity/
            </a>
          </li>
          <li>
            Uttara Kannada Spatial Decision Support System [UKSDSS]{" "}
            <a href="https://wgbis.ces.iisc.ac.in/sdss/uksdss/">
              https://wgbis.ces.iisc.ac.in/sdss/uksdss/
            </a>
          </li>
          <li>
            Karnataka: Natural Capital Accounting and Valuation of Ecosystem
            Services{" "}
            <a href="https://wgbis.ces.iisc.ac.in/sdss/ncaves_k/">
              https://wgbis.ces.iisc.ac.in/sdss/ncaves_k/
            </a>
          </li>
          <li>
            Natural Resource Rich Region [NRRR]: Karnataka{" "}
            <a href="https://wgbis.ces.iisc.ac.in/sdss/nrrr_k/">
              https://wgbis.ces.iisc.ac.in/sdss/nrrr_k/
            </a>
          </li>
          <li>
            Flora of Kerala-{" "}
            <a href="https://forest.kerala.gov.in/">
              https://forest.kerala.gov.in/
            </a>
          </li>
          <li>
            Eflora Kerala-{" "}
            <a href="https://www.eflorakerala.com/">
              https://www.eflorakerala.com/
            </a>
          </li>
          <li>
            Digital Flora-{" "}
            <a href="https://stthomas.ac.in/">https://stthomas.ac.in/</a>
          </li>
          <li>
            India Flora Online-{" "}
            <a href="https://indiaflora-ces.iisc.ac.in/">
              https://indiaflora-ces.iisc.ac.in/
            </a>
          </li>
          <li>
            Digital Flora of Karnataka-{" "}
            <a href="https://indiaflora-ces.iisc.ac.in/FloraKarnataka/">
              https://indiaflora-ces.iisc.ac.in/FloraKarnataka/
            </a>
          </li>
          <li>
            Flora of Peninsular India-{" "}
            <a href="https://indiaflora-ces.iisc.ac.in/FloraPeninsular/">
              https://indiaflora-ces.iisc.ac.in/FloraPeninsular/
            </a>
          </li>
          <li>
            Digital flora of Eastern Ghats-{" "}
            <a href="https://indiaflora-ces.iisc.ac.in/EasternGhats/">
              https://indiaflora-ces.iisc.ac.in/EasternGhats/
            </a>
          </li>
          <li>
            BSI Flora of India-{" "}
            <a href="https://efloraofindia.com/efi/bsi-flora-of-india/">
              https://efloraofindia.com/efi/bsi-flora-of-india/
            </a>
          </li>
          <li>
            eFloraofIndia-{" "}
            <a href="https://efloraofindia.com/">https://efloraofindia.com/</a>
          </li>
          <li>
            Org - <a href="http://www.efloras.org/">http://www.efloras.org/</a>
          </li>
          <li>
            The World Flora Online-{" "}
            <a href="https://www.worldfloraonline.org/">
              https://www.worldfloraonline.org/
            </a>
          </li>
          <li>
            World Flora Online-{" "}
            <a href="https://www.rbge.org.uk/science-and-conservation/major-floras/">
              https://www.rbge.org.uk/science-and-conservation/major-floras/
            </a>
          </li>
          <li>
            WFO plant list-{" "}
            <a href="https://wfoplantlist.org/">https://wfoplantlist.org/</a>
          </li>
          <li>
            Global Biodiversity Information Facility-{" "}
            <a href="https://www.gbif.org/">https://www.gbif.org/</a>
          </li>
          <li>
            Flora of the world-{" "}
            <a href="https://floraoftheworld.org/">
              https://floraoftheworld.org/
            </a>
          </li>
          <li>
            Global Plants-{" "}
            <a href="https://plants.jstor.org/">https://plants.jstor.org/</a>
          </li>
          <li>
            Globe Plants-{" "}
            <a href="https://globeplants.com/">https://globeplants.com/</a>
          </li>
          <li>
            World Flora Online-{" "}
            <a href="https://sweetgum.nybg.org/science/world-flora/">
              https://sweetgum.nybg.org/science/world-flora/
            </a>
          </li>
          <li>
            Plants of the World Online-{" "}
            <a href="https://powo.science.kew.org/">
              https://powo.science.kew.org/
            </a>
          </li>
          <li>
            Pteridophyte Collections Consortium{" "}
            <a href="https://www.pteridoportal.org/portal/collections/misc/collprofiles.php">
              https://www.pteridoportal.org/portal/collections/misc/collprofiles.php
            </a>
          </li>
          <li>
            Flora-{" "}
            <a href="http://old.forest.kerala.gov.in/index.php?option=com_content&amp;view=category&amp;layout=blog&amp;id=67&amp;Itemid=56">
              http://old.forest.kerala.gov.in/index.php?option=com_content&amp;view=category&amp;layout=blog&amp;id=67&amp;Itemid=56
            </a>
          </li>
          <li>
            Indian Biodiversity Information System-{" "}
            <a href="https://www.indianbiodiversity.org/">
              https://www.indianbiodiversity.org/
            </a>
          </li>
          <li>
            Flora of India-{" "}
            <a href="https://bsi.gov.in/">https://bsi.gov.in/</a>
          </li>
          <li>
            India Biodiversity Portal-{" "}
            <a href="https://indiabiodiversity.org/">
              https://indiabiodiversity.org/
            </a>
          </li>
          <li>
            IORA medicinal plants Database -{" "}
            <a href="https://cimap.res.in/">https://cimap.res.in/</a>
          </li>
          <li>
            Plants of South Asia-{" "}
            <a href="https://data.nhm.ac.uk/">https://data.nhm.ac.uk/</a>
          </li>
          <li>
            IBIS &ndash; Flora-{" "}
            <a href="https://www.indianbiodiversity.org/">
              https://www.indianbiodiversity.org/
            </a>
          </li>
          <li>
            Medicinal Plant Database-{" "}
            <a href="https://bsi.gov.in/">https://bsi.gov.in/</a>
          </li>
          <li>
            Digital Planty Atlas-{" "}
            <a href="https://www.plantatlas.eu/">https://www.plantatlas.eu/</a>
          </li>
          <li>
            EU- <a href="https://floraveg.eu/">https://floraveg.eu/</a>
          </li>
          <li>
            Pladias: Database of the Czech Flora and Vegetation-{" "}
            <a href="https://pladias.cz/en/">https://pladias.cz/en/</a>
          </li>
          <li>
            Pladias SK: Database of the Slovak Flora and Vegetation-{" "}
            <a href="https://pladias.sk/en/">https://pladias.sk/en/</a>
          </li>
          <li>
            EUNIS (European Nature Information System)-{" "}
            <a href="https://www.eea.europa.eu/">https://www.eea.europa.eu/</a>
          </li>
          <li>
            Biodiversity Information System of West Bengal-{" "}
            <a href="https://www.wbbis.wb.gov.in/">wbbis.wb.gov.in</a>
          </li>
          <li>
            The Woody Plants of Korea-{" "}
            <a href="https://florakorea.myspecies.info/en">
              https://florakorea.myspecies.info/en
            </a>
          </li>
          <li>
            National Biodiversity Portal-{" "}
            <a href="https://biomis.nic.in/">https://biomis.nic.in/</a>
          </li>
          <li>
            e-Flora of Jammu &amp; Kashmir-{" "}
            <a href="https://www.bhaderwahcampus.in/eflora/index.html">
              https://www.bhaderwahcampus.in/eflora/index.html
            </a>
          </li>
          <li>
            Haryana Forest Flora-{" "}
            <a href="https://www.haryanaforestflora.in/">
              https://www.haryanaforestflora.in/
            </a>
          </li>
          <li>
            Flowers of India-{" "}
            <a href="https://flowersofindia.net/">
              https://flowersofindia.net/
            </a>
          </li>
          <li>
            USDA PLANTS Database-{" "}
            <a href="https://www.nrcs.usda.gov/">https://www.nrcs.usda.gov/</a>
          </li>
          <li>
            Flora of the Southeastern United States (FSUS)-{" "}
            <a href="https://fsus.ncbg.unc.edu/">https://fsus.ncbg.unc.edu/</a>
          </li>
          <li>
            Flora of North America (FNA)-{" "}
            <a href="http://beta.floranorthamerica.org/Main_Page">
              http://beta.floranorthamerica.org/Main_Page
            </a>
          </li>
          <li>
            org-{" "}
            <a href="https://plantatlas.usf.edu/">
              https://plantatlas.usf.edu/
            </a>
          </li>
          <li>
            Swiss Biodiversity Forum-{" "}
            <a href="https://biodiversity.scnat.ch/portrait">
              https://biodiversity.scnat.ch/portrait
            </a>
          </li>
          <li>
            org- <a href="https://bplant.org/">https://bplant.org/</a>
          </li>
          <li>
            FloraWeb- <a href="https://floraweb.de/">https://floraweb.de/</a>
          </li>
          <li>
            InfoFlora-{" "}
            <a href="https://www.infoflora.ch/de/">
              https://www.infoflora.ch/de/
            </a>
          </li>
          <li>
            Reflora - Virtual Herbarium-{" "}
            <a href="https://www.gbif.org/">https://www.gbif.org/</a>
          </li>
        </ol>
      }
    />
  );
}

export default E_linksPage;
